export default class Scenario {
    constructor() {
        this.id = "";
        this.name = "";
        this.storyID = "";
        this.missionBriefingBackgroundImageId = "";
        this.previewBackgroundImageId = "";
        this.resultBackgroundImageId = "";
        this.feedbackBackgroundImageId = "";
        this.reflectionBackgroundImageId = "";
        this.story = null;
        this.problemModel = null;
    }
}